module.exports = __webpack_public_path__ + "static/media/neev_life.55ab4078.png";


//////////////////
// WEBPACK FOOTER
// ./src/brand-logos/neev_life.png
// module id = 1059
// module chunks = 0